// TaskNotificationListener — mounted once in App.tsx (behind FEATURES.taskBoard).
//
// A task notification row written for the signed-in person (assigned to a
// task, mentioned in a comment, a comment on their task — services/tasks.ts)
// becomes a bell entry and a toast the moment it lands, on whatever page they
// are on. Phones get the same row as a push through push-dispatch (0091's
// trigger); this is the console's copy.
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { addNotification } from '../services/notificationCenter';
import { subscribeMyTaskNotifications, TASK_BOARD_ROLES, USE_SUPABASE } from '../services/tasks';

export const taskNotificationUrl = (taskId: string): string => `/tasks?task=${encodeURIComponent(taskId)}`;

export const TaskNotificationListener: React.FC = () => {
  const { currentUser, showToast } = useApp();
  const navigate = useNavigate();
  const uid = currentUser?.id;
  const role = currentUser?.role;

  useEffect(() => {
    if (!USE_SUPABASE || !uid || !role || !TASK_BOARD_ROLES.includes(role)) return;
    return subscribeMyTaskNotifications(uid, (n) => {
      const url = taskNotificationUrl(n.taskId);
      addNotification({
        title: n.title,
        body: n.body,
        data: { type: 'task', taskId: n.taskId, fromUserId: n.actorId ?? undefined },
        url,
        tag: `task:${n.taskId}:${n.kind}`,
      });
      showToast(n.body, 'info', { title: n.title, onClick: () => navigate(url) });
    });
    // showToast / navigate are stable enough for the life of a session; the
    // subscription must not be torn down on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, role]);

  return null;
};
